import { render } from "./NftCard.vue?vue&type=template&id=2349a9d2&scoped=true"
import script from "./NftCard.vue?vue&type=script&lang=js"
export * from "./NftCard.vue?vue&type=script&lang=js"

import "@/Common/Styles/poolNftCard.scss?vue&type=style&index=0&id=2349a9d2&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2349a9d2"]])

export default __exports__